import React from "react";
import "./navigation.scss";

/**
 * Functional component to return and inline navigation
 *
 * Each link supports an optional `disabled` flag — when set, the tab
 * renders muted, ignores clicks, and shows a tooltip ("Coming soon" by
 * default, overridable via `link.tooltip`).
 */
function Navigation(props) {
    /**
     * Deconstruct the data needed from the props
     */
    const { links, active, onClick } = props;

    return (
        <div className={["ui-horizontal-nav", props.center && "is-center", props.children && "has-actions"].filter(Boolean).join(" ")}>
            {links.map((link) => {
                if (link.divider) {
                    return (
                        <div
                            key={link.id}
                            className={[
                                "ui-horizontal-nav-divider",
                                link.spaced && "is-spaced",
                            ].filter(Boolean).join(" ")}>
                            {link.label}
                        </div>
                    );
                }

                const isActive = link.id === active;
                const isDisabled = !!link.disabled;
                const tooltip = link.tooltip || (isDisabled ? "Coming soon" : undefined);

                return (
                    <div
                        key={link.id}
                        className={[
                            "ui-horizontal-nav-link",
                            isActive && "is-active",
                            isDisabled && "is-disabled",
                            link.actions && "has-actions",
                            link.alignRight && "align-right",
                        ].filter(Boolean).join(" ")}
                        onClick={() => !isDisabled && onClick(link.id)}
                        title={tooltip}
                        aria-disabled={isDisabled || undefined}>

                        {link.label}

                        {(link.count && link.count > 0) ?
                            <small>{link.count}</small> : ""
                        }

                        {link.actions && (
                            <div className="ui-horizontal-nav-popover">
                                {link.actions.map((action) => (
                                    <button
                                        key={action.label}
                                        type="button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            action.onClick();
                                        }}>
                                        {action.label}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                );
            })}
            {props.children && <div className="ui-horizontal-nav-actions">{props.children}</div>}
        </div>
    );
}

export default Navigation;